module.exports = __webpack_public_path__ + "img/sec2.1.38a5d0bb.png";